<template>
  <router-link
    v-if="to !== undefined"
    custom
    v-slot="{ navigate }"
    :to="to"
  >
    <tr 
      role="button" 
      v-bind="$attrs" 
      @click="navigate"
      class="align-middle bg-white border-gray-100 last:border-gray-200 border-b border-solid"
    >
      <slot />
    </tr>
  </router-link>
  <tr 
    v-else 
    v-bind="$attrs"
    class="align-middle bg-white border-gray-100 last:border-gray-200 only:border-gray-100 border-b border-solid"
    @click="onRowClick"
  >
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { RouterLink, type RouteLocationRaw } from 'vue-router';

interface FTrEmits {
  (e: 'click'): void;
}

interface FTrProps {
  to?: RouteLocationRaw;
}

defineProps<FTrProps>();
const emits = defineEmits<FTrEmits>();

const onRowClick = () => {
  emits('click');
};
</script>